import { lazy } from "react";
// ===========================================================================
// Playground (Módulo DEV-ONLY) — entry point.
//
// Solo se monta en desarrollo (NODE_ENV === "development"). El gating se hace
// con PLAYGROUND_ENABLED en AppRouter (rutas) y navigationConfig (sidebar).
// Ver common/constants.js para el detalle del gating.
// ===========================================================================
import { PLAYGROUND_ENABLED } from "./common/constants";

const PlaygroundPage = lazy(() => import("./pages/PlaygroundPage"));

// El módulo resuelve su propio gating: en producción no publica rutas.
// No lleva RoleGuard porque no está en el mapa RBAC (es exclusivo de dev).
export const playgroundRoutes = PLAYGROUND_ENABLED
  ? [{ path: "/playground", element: <PlaygroundPage />, noRoleGuard: true }]
  : [];

export { PlaygroundPage };
export { PLAYGROUND_ENABLED, PLAYGROUND_BASE_PATH } from "./common/constants";
export default PlaygroundPage;
